module.exports = __webpack_public_path__ + "static/img/Paul.Little.fc2fa37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Paul.Little.jpg
// module id = Fkj6
// module chunks = 0